import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { CustomTabPanel, a11yProps } from '../../../components/Atoms/CustomTabPanel';
import { Title } from '../../../components/Atoms/Title';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AddAlertByAddressTab from '../components/AddAlertByAddressTab';
import AreaSelectTab from '../components/AreaSelectTab';
import { AddAlertByRiverLevelTab } from '../components/AddAlertByRiverLevelTab';
import { useLocation } from 'react-router-dom';
import { sendAnalyticsEvent } from '../../../utils/googleAnalytics';

const AddNewAlert: React.FC = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    // GA4: アラート登録方式タブの変更を計測
    sendAnalyticsEvent('alert_form', {
      action: 'change_tab',
      alert_type: ['point', 'area', 'river_level'][newValue],
    });
    setTabValue(newValue);
  };

  const location = useLocation();
  const is_detail = new URLSearchParams(location.search).get('is_detail') === 'true';

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('is_area') === 'true') {
      setTabValue(1);
    } else if (params.get('is_river') === 'true') {
      setTabValue(2);
    }
    return;
  }, [location]);

  const is_edit = location.pathname.indexOf('/edit_alert') !== -1;
  return (
    <Box style={{ padding: '24px 24px 0px 24px' }}>
      <Title>{is_edit ? t('common.menu.editAlert') : t('common.menu.addNewAlert')}</Title>
      <Typography>{t('pages.alerts.addNewAlert.desc')}</Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: '16px' }}>
        <Tabs
          TabIndicatorProps={{
            style: {
              backgroundColor: 'green',
            },
          }}
          value={tabValue}
          onChange={is_detail || is_edit ? undefined : handleTabChange}
          aria-label="basic tabs example"
          style={{ borderBottom: 'none' }}
        >
          <Tab
            label={t('pages.alerts.addByAddress')}
            {...a11yProps(0)}
            style={{
              color: tabValue === 0 ? 'green' : 'gray',
            }}
            disabled={is_detail || is_edit}
          />
          <Tab
            label={t('pages.alerts.addByArea')}
            {...a11yProps(1)}
            style={{
              color: tabValue === 1 ? 'green' : 'gray',
            }}
            disabled={is_detail || is_edit}
          />
          <Tab
            label={t('pages.alerts.addByRiverLevel')}
            {...a11yProps(2)}
            style={{
              color: tabValue === 2 ? 'green' : 'gray',
            }}
            disabled={is_detail || is_edit}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={tabValue} index={0}>
        <AddAlertByAddressTab />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <AreaSelectTab />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={2}>
        <AddAlertByRiverLevelTab />
      </CustomTabPanel>
    </Box>
  );
};

export default AddNewAlert;
